export type BillingCycle="monthly"|"yearly";
export const money=(amount:number)=>amount.toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})+' TL';
export function annualTotal(monthly:number,discount:number){return Math.round(Math.round(monthly*100)*12*(100-discount)/100)/100;}
